import * as React from 'react';

interface Props {
    html: string;
    className: string;
}
export default class HtmlContent extends React.PureComponent<Props> {
    static defaultProps = {
        className: '',
    };

    render() {
        const { className, html } = this.props;

        const classNames: Array<string> = ['ddbc-html-content', className];

        return <div className={classNames.join(' ')} dangerouslySetInnerHTML={{ __html: html }} />;
    }
}
